export enum PickingRoutes {
    IDLE = "pickingIdle",
    SETTINGS = "pickingSettings",
    LOAD_CONTAINER = "pickingLoadContainer",
    SIGNIN = "pickingLogin",
    PICKING_CONTAINER = "pickingCartView",
}

export enum TestPickingRoutes {
    IDLE = "testPickingIdle",
    SETTINGS = "testPickingSettings",
    LOAD_CONTAINER = "testPickingLoadContainer",
    SIGNIN = "testPickingLogin",
    PICKING_CONTAINER = "testPickingCartView",
}
